module.exports = __webpack_public_path__ + "static/img/LOGO.409f8c83.svg";